import { type QueryKey } from '@tanstack/react-query'
import { createContext } from 'react'

type StripeCardsContextValue = {
  getStripeCardsQueryKey: QueryKey
}

const StripeCardsContext = createContext<StripeCardsContextValue>({
  getStripeCardsQueryKey: [],
})

export default StripeCardsContext
